import * as React from "react";
function SvgTelemedicine(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.815 18.209a2.796 2.796 0 01-.276-.397.376.376 0 00-.325-.188H4.875a.375.375 0 01-.375-.374V5.625a.375.375 0 01.375-.375h8.25a.375.375 0 01.375.375v1.32a.375.375 0 00.375.374c.224 0 .447.025.665.075a.375.375 0 00.46-.367V5.25A2.257 2.257 0 0012.75 3h-7.5A2.257 2.257 0 003 5.25v13.5A2.257 2.257 0 005.25 21h4.084a.374.374 0 00.288-.615l-1.807-2.176zm.247-5.834h1.125a.567.567 0 00.563-.563v-.75a.188.188 0 01.187-.187h.75a.187.187 0 00.188-.188v-.367c0-.396.08-.788.236-1.151a.375.375 0 00-.172-.48.54.54 0 00-.252-.064h-.75a.187.187 0 01-.187-.188v-.75a.566.566 0 00-.563-.563H8.062a.566.566 0 00-.562.563v.75a.187.187 0 01-.188.187h-.75A.566.566 0 006 9.187v1.125a.566.566 0 00.562.562h.75a.187.187 0 01.188.188v.75a.566.566 0 00.562.563zm7.688 1.875h1.5A3.754 3.754 0 0121 18v2.25a.75.75 0 01-1.5 0V18a2.25 2.25 0 00-2.25-2.25H15a.75.75 0 01-.75-.75v-4.875a.375.375 0 00-.75 0v7.368a.75.75 0 01-1.327.48l-1.76-2.116a.375.375 0 00-.577.479l2.854 3.434a.75.75 0 11-1.154.96l-2.854-3.435a1.874 1.874 0 01.886-2.99 1.877 1.877 0 011.998.59l.434.526v-5.296a1.875 1.875 0 013.75 0v4.125z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgTelemedicine);
export default ForwardRef;
